/**
 * @generated SignedSource<<3ba132ea9c14e33aa965ab979f98a04b>>
 * @relayHash 2f07e2124d8bff0f22876d1f29121d54
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0dfca411c693c7c48cd45eee70c52b59e262879cfd0e96f513ac36c51dbffeb2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcVirtualAgentViewIntentQuery } from './srcVirtualAgentViewIntentQuery.graphql';

const node: PreloadableConcreteRequest<srcVirtualAgentViewIntentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0dfca411c693c7c48cd45eee70c52b59e262879cfd0e96f513ac36c51dbffeb2",
    "metadata": {},
    "name": "srcVirtualAgentViewIntentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
